import React from "react";
import { Link } from "react-router-dom";
import narrativeLogo from "./narrative.png";
import LoggedInName from "./LoggedInName";

const Header = () => {
  return (
    <nav className="flex items-center bg-white p-6">
      <div className="mr-6 w-48">
        <Link to="/">
          <img src={narrativeLogo} alt="Canvas Logo" />
        </Link>
      </div>
      <LoggedInName />
    </nav>
  );
};

export default Header;
